<template>
  <div class="data_content">
    <el-image :src="mataInfo.url" style="width: 100%;height: 100%"></el-image>
    <div class="xuanfu-anniu">
      <el-button @click="showqianming" :disabled="countdown > 0" v-if="mataInfo.isSing == 0" type="primary">
        {{ countdown > 0 ? countdown : "" }}签名
      </el-button>
    </div>

    <el-dialog title="确认签名"
               append-to-body
               :visible.sync="signreVisible"
               :close-on-click-modal="false"
               width="99%">

      <el-form style="height: 95%">
        <vue-esign
            ref="esign"
            :height="900"
            :isCrop="isCrop"
            :lineWidth="lineWidth"
            :lineColor="lineColor"
            :format="'image/png'"
            :bgColor.sync="bgColor"
        ></vue-esign>
        <el-row>
          <el-col :span="24" style="width: 100%;display: flex;justify-content: center">
            <el-button type="danger" @click="handleReset">清空画板</el-button>
            <el-button type="primary" @click="handleGenerate">确认签名</el-button>
<!--            <el-button type="danger" @click="closeqianming">关闭</el-button>-->
          </el-col>
        </el-row>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>

import vueEsign from "vue-esign";

export default {
  data() {
    return {
      signreVisible: false,
      lineWidth: 15,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,
      countdown: 2,
      uploadurl: '/api/check/player/uploadFile',
      getoneUrl: '/api/match/getoneuser',
      mataInfo: {}
    };
  },
  created() {
    const times = setInterval(() => {
      this.countdown--; //递减
      if (this.countdown === 0) {
        // === 0 变成获取按钮
        clearInterval(times);
        this.isCounting = false;
      }
    }, 1000);
    this.getinfo()
  },
  comments: {},
  methods: {
    showqianming() {
      this.signreVisible = true
      this.$nextTick(() => {
        this.$refs.esign.reset()
        this.resultImg = ''
      });
    },
    closeqianming() {
      this.$refs.esign.reset()
      this.resultImg = ''
      this.signreVisible = false
    },

    // 清空画板..
    handleReset() {
      // this.$refs.esign.undoSignature()
      this.$refs.esign.reset()
      this.resultImg = ''
    },
    // 生成签名图片..
    handleGenerate() {
      this.$refs['esign']
          .generate()
          .then((res) => {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            console.log(res)
            this.resultImg = res // 得到了签字生成的base64图片
            const bl = this.dataURLtoFile(res)
            let formData = new FormData()
            formData.append('file', bl, Date.now() + '.png')
            let config = {headers: {"Content-Type": "multipart/form-data"}};
            config.headers.id = this.marathonId;
            config.headers.token = sessionStorage.getItem('token');
            // 接口请求
            this.$axios.post(
                this.uploadurl,
                formData,
                config,
            ).then(res => {
              if (res.data.succeeded) {
                this.signreVisible = false
                this.getinfo();
                loading.close()
              }
            }).catch(error => {

            });

          }).catch((err) => {
        // 没有签名，点击生成图片时调用
        this.$message({
          type: 'warning',
          message: "签名内容不能为空"
        });
      })
    },
    // 将base64转成blob流
    dataURLtoFile(urlData) {
      const type = 'image/png'
      let bytes = null
      if (urlData.split(',').length > 1) {
        bytes = window.atob(urlData.split(',')[1])
      } else {
        bytes = window.atob(urlData)
      }
      let ab = new ArrayBuffer(bytes.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }
      return new Blob([ab], {type})
    },
    getinfo() {
      this.$axios.get(
          this.getoneUrl,
          {
            params: {
              id: sessionStorage.getItem('marathonId')
            }
          }
      ).then(res => {
        if (res.data.succeeded) {
          this.mataInfo = res.data.obj
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          });
        }
        this.listLoading = false;
        // eslint-disable-next-line handle-callback-err
      }).catch(error => {

      });
    }
  },
  computed: {}
};
</script>


<style scoped>
.data_content {
  overflow: hidden;
  width: 100%;
  height: 100vh;
  background-color: #081832;
}

button {
  height: 40px;
}

.contro-container {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background-color: #d3d3d3;
  position: absolute;
  bottom: 0px;
}

.xuanfu-anniu {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background-color: #0077cc;
  color: #fff;
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/views/data_screen/data_screen.vue